<template>
  <div class="registerCardStyle">
    <UserBase
      :title="$t('nextengine.nextengine_cooperate-confirm-title')"
      :isShowToLogin="isShowToLogin"
    >
      <template #default>
        <div class="caution">
          {{ $t('nextengine.nextengine_cooperate-confirm-message1') }}
        </div>
        <v-row no-gutters class="py-2" justify="center" align-content="center">
          <v-col cols="10">
            {{ $t('user.user_organization-name') }}：{{
              userInfo.organizationName
            }}
          </v-col>
        </v-row>
        <!-- ネクストエンジン連係の主体選択機能はコメントアウト
        <v-row no-gutters class="py-2" justify="center" align-content="center">
          <v-col cols="10">
            {{ $t('nextengine.nextengine_cooperate-confirm-message2') }}
            <v-radio-group v-model="userInfo.controlType" column>
              <v-radio
                :value="1"
                :label="$t('common.common_nextengine')"
              ></v-radio>
              <v-radio :value="2" :label="$t('common.common_spes')"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        -->
        <v-spacer class="pa-3" />
        <v-row no-gutters justify="center" align-content="center">
          <v-col cols="10">
            <NormalButton
              :text="$t('nextengine.nextengine_cooperate-confirm-button')"
              height="50px"
              @click="execNextengineCooperate"
            />
          </v-col>
        </v-row>
      </template>
    </UserBase>
    <TermsDialog v-model="dialogParams" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { UserBase } from '@/components/layouts'
import { NormalButton } from '@/components/items'
import { TermsDialog } from '@/components/layouts/Dialogs'
import { TO_STATUS } from '@/config/master/tutorial'

export default {
  components: {
    UserBase,
    NormalButton,
    TermsDialog
  },
  data: () => {
    return {
      userInfo: {
        neUid: null,
        neState: null,
        organizationName: null,
        controlType: 1,
        tutorialStatus: 1
      },
      dialogParams: {
        dialog: false,
        type: 'TERMS'
      },
      isFetching: false
    }
  },
  created() {
    const { uid, state } = this.$route.query
    if (uid) {
      this.userInfo.neUid = uid
    }
    if (state) {
      this.userInfo.neState = state
    }

    // ユーザー情報を取得
    this.fetchUserInfo()
    // userInfo の中身を確認
    //console.log('userInfo:', this.userInfo)
  },
  computed: {
    isShowToLogin() {
      return this.$route.query.token ? true : false
    }
  },
  methods: {
    ...mapActions('User', ['getUserInfoFromApi', 'getUserInfoFromState']),
    ...mapActions('Nextengine', ['cooperateNextengineFromApi']),
    async fetchUserInfo() {
      const userInfo = await this.getUserInfoFromApi()
      this.userInfo.organizationName = userInfo.data.organization.name
      this.userInfo.tutorialStatus = userInfo.data.tutorialStatus
    },
    async execNextengineCooperate() {
      const success = await this.cooperateNextengineFromApi({
        //controlType: this.userInfo.controlType,
        controlType: 1, // ネクストエンジン側主体で固定
        neUid: this.userInfo.neUid,
        neState: this.userInfo.neState
      })

      if (success) {
        alert(this.$t('nextengine.nextengine_cooperate-success-message'))
        // 通常のルーティング処理
        const tutorialStatus = this.userInfo.tutorialStatus
        if (tutorialStatus === TO_STATUS.OPENED) {
          this.$router.push({ name: 'dashboard' }).catch(() => {})
          return
        }
        this.$router.push({ name: 'tutorial' }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.registerCardStyle {
  .terms {
    font-size: 12px !important;
  }
}

.caution {
  width: 100%;
  text-align: center;
  white-space: pre-wrap;
  color: #666666;
  line-height: 30px;
  margin-bottom: 20px;
}
</style>
